import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=08b8ff18&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"
import style0 from "./Footer.vue?vue&type=style&index=0&id=08b8ff18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b8ff18",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgRender: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/SvgRender.vue').default,Link: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/Link.vue').default,Button: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/Button.vue').default,Layout: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/Layout.vue').default})
